var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStapler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3541 13.9958H20V9.17285L10.3541 13.9958Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 18.6185V19.9958C2 20.5481 2.44772 20.9958 3 20.9958H21C21.5523 20.9958 22 20.5481 22 19.9958V17.9958C22 17.4435 21.5523 16.9958 21 16.9958H8.20924C7.61586 18.4617 6.17869 19.4958 4.5 19.4958C3.55405 19.4958 2.6848 19.1674 2 18.6185Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11.5715V15.4958C2 16.8765 3.11929 17.9958 4.5 17.9958C5.88071 17.9958 7 16.8765 7 15.4958V14.5311C7 14.203 7.18536 13.9031 7.47881 13.7564L20.759 7.11626C21.3695 6.81101 21.5016 5.99737 21.0189 5.51473L19.6759 4.17167C18.3931 2.88891 16.4077 2.63002 14.8389 3.54094L2.49786 10.7067C2.18967 10.8857 2 11.2151 2 11.5715ZM4.5 16.4958C3.94772 16.4958 3.5 16.0481 3.5 15.4958C3.5 14.9435 3.94772 14.4958 4.5 14.4958C5.05228 14.4958 5.5 14.9435 5.5 15.4958C5.5 16.0481 5.05228 16.4958 4.5 16.4958Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStapler);
export default __webpack_public_path__ + "static/media/stapler.88851a94b9b30b230b16a3979817de1b.svg";
export { ForwardRef as ReactComponent };